import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <path d="M25,25.94c-5.07,0-20.66,4.13-20.66,11.27v7.51A3.77,3.77,0,0,0,8.1,48.47H41.9a3.77,3.77,0,0,0,3.76-3.75V37.21C45.66,30.07,30.07,25.94,25,25.94Z" />
    <path d="M25,2.53A11.27,11.27,0,1,0,36.27,13.79,11.3,11.3,0,0,0,25,2.53Z" />
  </Base>
);
